class ImageWithTextGrid extends HTMLElement {
    constructor() {
        super();
        this.config = new TinySliderConfig().generateConfig(this);

        if (!window.matchMedia('(min-width: 768px)').matches) {
            this.slider = tns({
                ...this.config,
            });
        }
    }
}

customElements.define('image-with-text-grid', ImageWithTextGrid);
